import { ListItem } from "@mui/material";

import MultiSelectFilterV3 from "./MultiSelectFilterV3";

export default function FollowUpFilter({
  selectedItems,
  setSelectedItems,
  setActiveItems,
  activeItems,
  resetPagination,
  setFilterState,
}) {
  const setSelectedState = (selectedValues) => {
    setSelectedItems(selectedValues);
    setFilterState({ fieldName: "followUpFilter", data: selectedValues });
  };

  return (
    <ListItem>
      <div className="w-full p-2 shadow">
        <MultiSelectFilterV3
          title="Filter by Follow Up Types"
          selectedItems={selectedItems}
          setSelectedItems={setSelectedState}
          setActiveItems={setActiveItems}
          activeItems={activeItems}
          nameKey="label"
          valueKey="key"
          resetPagination={resetPagination}
          searchTitle="Follow Ups"
          apiUrl={`core/dynamic-options/action_types`}
          buttonFullW={true}
          dropdown={false}
          filterName={"followUpFilter"}
          setFilterState={setFilterState}
        />
      </div>
    </ListItem>
  );
}
